import styled from "styled-components";

export const Info = styled.div`
  font-family: ${({ theme }) => theme.default.fontFamily.primaryFont};
  display: flex;
  align-items: flex-start;
  justify-content: center;
  flex-direction: column;
  font-size: 12px;
`;

export const DateTimeWrapper = styled.div`
  color: ${({ theme }) => theme.default.color.text.dark};
`;
